import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type ToggleButtonStateKey } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class ToggleButtonPropsBuilder extends PropsBuilder<'toggleButton'> {
  override setMargin = (margin: string | undefined): this => {
    this.patchProps({ style: { button: { offset: { margin } } } });
    return this;
  };

  override setInitialToggleState = (state: ToggleButtonStateKey | undefined): this => {
    if (!state) {
      return this;
    }
    this.patchProps({ content: { toggle: { defaultState: state } } });
    return this;
  };

  constructor(props: PartialPropsOf<'toggleButton'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
